/**
 * ConfirmModal - Generic confirmation modal
 */
import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({
  isOpen = false,
  onClose,
  onConfirm,
  title = 'Confirmation',
  message,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  confirmVariant = 'primary',
  icon = 'bi-question-circle',
  children
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const variantClass = confirmVariant === 'danger' ? 'confirm-danger'
    : confirmVariant === 'warning' ? 'confirm-warning'
    : '';

  return (
    <>
      {/* Modal backdrop */}
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
        style={{ zIndex: 1040 }}
      ></div>

      {/* Modal */}
      <div
        className="modal fade show d-block confirm-modal"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {icon && <i className={`bi ${icon} me-2`}></i>}
                {title}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {message && <p>{message}</p>}
              {children}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="confirm-btn-cancel"
                onClick={onClose}
              >
                {cancelLabel}
              </button>
              <button
                type="button"
                className={`confirm-btn-confirm ${variantClass}`}
                onClick={handleConfirm}
              >
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmModal;
